module.exports = __webpack_public_path__ + "img/Balle2.f6143810.svg";